import { ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { AlkEvent, BaseView } from '@wizeoo/akm-common-lib';
import { WizEventManager, WizRoot } from '@wizeoo/akm-component-lib';

import { RouteEngine } from 'src/app/manager/routing/route.engine';
import { APP_EVENT_TYPE } from 'src/app/model/enums';

import { Model } from 'src/app/model/model';

@Component({
  selector: 'init-view',
  templateUrl: './init.view.html',
})
// Vue d'initialisation pour chargement du contexte
export class InitView extends BaseView {

  constructor(public elementRef: ElementRef, public cdref: ChangeDetectorRef ) {
    super(elementRef);
    this.code = 'INIT';
  }

  /**
   * Synchronisation des données
   */
  public wizSynchronizeData(): void {
    
    Model.getInstance().currentViewCode = this.code;

    // alimentation du bread
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(APP_EVENT_TYPE.BREAD, '$.common.home.$'));
  }

    /** déclenche une action */
    public do(action: string): void {
      switch (action) {   
        case "list":               
          Model.getInstance().navigationEngine.navigate(RouteEngine.LIST_VIEW);
          break; 
        case "thumb":               
          Model.getInstance().navigationEngine.navigate(RouteEngine.THUMB_VIEW);
          break;  
        case "gatling":               
          Model.getInstance().navigationEngine.navigate(RouteEngine.GATLING_VIEW);
          break; 
        case "log":               
          Model.getInstance().navigationEngine.navigate(RouteEngine.LOG_VIEW);
          break;       
        case "add":  
            Model.getInstance().currentPrototype = null;
            Model.getInstance().navigationEngine.navigate(RouteEngine.ADD_VIEW);
      }
    }


}